import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-webiat-text-area',
  templateUrl: './webiat-text-area.component.html',
  styleUrl: './webiat-text-area.component.scss'
})
export class WebiatTextAreaComponent implements OnInit{
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() maxlength!: number;
  @Input() isLengthLimited: boolean = true;
  @Input() control: FormControl = new FormControl();
  @Input() showIcon: boolean = false;
  @Input() iconPath: string = '';
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false; // Nouvel attribut pour indiquer si le champ est requis
  @Output() textChanged = new EventEmitter<string>();

  public value: string = '';
  public isFocused: boolean = false;
  public characterLimit: number = 60;
  public showCharacterCount: boolean = false;
  public isTouched: boolean = false;


  ngOnInit(): void {
    if (this.maxlength) {
      this.characterLimit = this.maxlength;
    }
  }

  public hasError(errorType: string): boolean {
    return this.control.hasError(errorType) && this.control.touched;
  }

  public onFocus(): void {
    this.isFocused = true;
    this.isTouched = true;
    this.showCharacterCount = true;
  }

  onTextChanged(event: any) {
    let inputValue = event.target.value;

    // Clean input (same logic as input component)
    inputValue = inputValue
      .replace(/[^a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>+\-/;µ§¨£ù°=`ØŒœ»©™▀²ôÔéàêâîï¤çèÉÀÿŸûÛüÜæÆëËÊÂÎÏÇÈÙ'~\[\]\\_]|(\d\uFE0F\u20E3)|([#*]\uFE0F\u20E3)/g, '')
      .replace(/^\s+/, '')
      .replace(/\s{2,}/g, ' ');

    this.value = inputValue;
    this.textChanged.emit(this.value);

      if (this.isLengthLimited && inputValue.length > this.maxlength) {        
        inputValue = inputValue.substring(0, this.maxlength);        
        this.value = inputValue;
        this.textChanged.emit(this.value);
      }
  }
}
